import styles from './Loader.module.scss';

export const Loader = () => {
    return <span className={styles.loader} />;
};